import React from 'react';
import { X } from 'lucide-react';

// Tag Chip Component
const TagChip = ({ label, onRemove, removable = true }) => (
    <span className="inline-flex items-center gap-1 px-2 py-1 bg-stone-100 rounded text-xs text-stone-600 border border-stone-200">
        {label}
        {removable && (
            <button onClick={onRemove} className="text-stone-400 hover:text-stone-600">
                <X className="w-3 h-3" />
            </button>
        )}
    </span>
);

export default TagChip;
